import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker. As of the "stop super-stale clients" change the
 * SW is built with `selfDestroying: true` (see vite.config.mts), so this no
 * longer installs a caching worker — it installs one that immediately
 * unregisters itself and clears any Workbox caches left by the old `autoUpdate`
 * SW. Registering it is still required so already-installed clients pick up the
 * self-destroying worker and heal.
 *
 * Freshness is now owned by HTTP cache headers (vercel.json) + the in-app
 * version check (src/lib/auto-update), not the service worker.
 */
export function registerPWA() {
  const updateSW = registerSW({
    onNeedRefresh() {
      // No-op: updates are handled by src/lib/auto-update, not the SW.
    },
    onOfflineReady() {
      // No-op: the self-destroying SW provides no offline support.
    },
  });

  return updateSW;
}
